﻿class ESModal extends HTMLElement {
  constructor() {
    super();
    this.close = this.close.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onBackdropClick = this.onBackdropClick.bind(this);
    this.closeButton = null;
  }

  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (this.dialog) {
      this.dialog.addEventListener('close', this.onClose);
      this.dialog.addEventListener('click', this.onBackdropClick);
    }

    this.closeButton = this.querySelector('.modal__close');
    this.closeButton?.addEventListener('click', this.close);
  }

  /* Every listener added above is removed here. The backdrop handler used to be an inline arrow,
     so it could never be detached and a reconnect stacked a second copy on the same dialog. */
  disconnectedCallback() {
    if (this.dialog) {
      this.dialog.removeEventListener('close', this.onClose);
      this.dialog.removeEventListener('click', this.onBackdropClick);
    }

    this.closeButton?.removeEventListener('click', this.close);
    this.closeButton = null;

    if (this.isOpen && window.ESScrollLock) {
      window.ESScrollLock.releaseLock(this.id || 'modal');
    }
  }

  onBackdropClick(event) {
    if (event.target === this.dialog) {
      this.close();
    }
  }

  open(opener) {
    this.openedBy = opener;
    if (this.dialog) {
      this.dialog.showModal();
    }
    this.isOpen = true;
    if (window.ESScrollLock) {
      window.ESScrollLock.requestLock(this.id || 'modal');
    }
    if (this.openedBy) {
      this.openedBy.setAttribute('aria-expanded', 'true');
    }
  }

  close() {
    if (this.dialog) {
      this.dialog.close();
    }
    this.isOpen = false;
  }

  onClose() {
    if (window.ESScrollLock) {
      window.ESScrollLock.releaseLock(this.id || 'modal');
    }
    if (this.openedBy) {
      this.openedBy.setAttribute('aria-expanded', 'false');
      if (document.body.contains(this.openedBy)) {
        this.openedBy.focus();
      }
    }
  }
}

if (!customElements.get('es-modal')) {
  customElements.define('es-modal', ESModal);
}
